/**
 * Konvertiert ein Polygon zu YOLO Segmentation Format
 * YOLO Segmentation Format: class_id x1 y1 x2 y2 x3 y3 ... (alle Werte normalisiert 0-1)
 * 
 * @param {Array<{x: number, y: number}>} polygon - Polygon-Punkte in Pixel-Koordinaten
 * @param {number} imageWidth - Breite des Bildes in Pixeln
 * @param {number} imageHeight - Höhe des Bildes in Pixeln
 * @param {number} classId - Klassen-ID (0-indexiert)
 * @returns {string} YOLO Segmentation Format String: "class_id x1 y1 x2 y2 x3 y3 ..."
 */
export const normalizePolygonToYOLO = (polygon, imageWidth, imageHeight, classId) => {
    if (!polygon || polygon.length < 3 || imageWidth <= 0 || imageHeight <= 0) {
        return null;
    }

    // Normalisiere alle Punkte auf 0-1
    const normalizedPoints = polygon.map(point => {
        const normalizedX = Math.max(0, Math.min(1, point.x / imageWidth));
        const normalizedY = Math.max(0, Math.min(1, point.y / imageHeight));
        return { x: normalizedX, y: normalizedY };
    });

    // Erstelle YOLO-Format String: class_id x1 y1 x2 y2 x3 y3 ...
    const pointStrings = normalizedPoints.map(p => 
        `${p.x.toFixed(6)} ${p.y.toFixed(6)}`
    ).join(' ');

    return `${classId} ${pointStrings}`;
};

/**
 * Generiert eine YOLO Segmentation Label-Datei für mehrere Objekte
 * @param {Array<Object>} polygons - Array von Polygonen mit classId und points
 * @param {number} imageWidth - Breite des Bildes
 * @param {number} imageHeight - Höhe des Bildes
 * @returns {string} YOLO Segmentation Label-String (mehrere Zeilen, eine pro Objekt)
 */
export const generateYOLOSegmentationLabel = (polygons, imageWidth, imageHeight) => {
    if (!polygons || polygons.length === 0) return '';

    const labelLines = polygons
        .filter(poly => poly.classId !== undefined && poly.classId !== null && poly.points && poly.points.length >= 3)
        .map(poly => {
            const yoloLine = normalizePolygonToYOLO(
                poly.points,
                imageWidth,
                imageHeight,
                poly.classId
            );
            return yoloLine;
        })
        .filter(line => line !== null);

    return labelLines.join('\n');
};

